import React from 'react';
import UploadFormTable from '../../Reusable/UploadFormTable';
import InputField from '../../Reusable/InputField';
import withTranslations from '../../../utils/HighOrderComponent';
import AttachmentTable from '../../Reusable/AttachmentTable/AttachmentTable';

const ThirdStep = (props) => {
  const { Placeholders } = props.t || {};
  return (
    <div className="col-md-9 m-auto mb-5">
      <div className="form-group">
        {props.attachmentsForPreview.length > 0 && (
          <AttachmentTable
            attachments={props.attachmentsForPreview}
            handleDownload={props.downloadAttachment}
            controllerReference={'requestForSignetApprovalAttachment'}
            handleDeleteDocument={props.handleDeleteDocumentUploaded}
            signal={true}
          />
        )}
        <UploadFormTable
          name="uploadedFiles"
          onChange={props.onFileChange}
          handleDeleteDocument={props.handleDeleteDocument}
          uploadedFiles={props.uploadedFiles}
          placeholder={Placeholders.upload}
          errors={props.errors?.uploadedFiles}
          enableMultiple={true}
        />
      </div>
      <InputField
        name="note"
        multiline={true}
        rows={4}
        placeholder={Placeholders.note}
        onChange={props.onChange}
        value={props.note}
      />
    </div>
  );
};

export default withTranslations(ThirdStep, 'ThirdStep');
